import React from "react";
import upload from "../../assets/Icons/upload.svg";
import uploadImg from "../../assets/Images/Upload-video-preview.jpg";
import { Link } from "react-router-dom";
import "./Upload.scss";
import axios from "axios";

const videoLink = "https://brainflix-api-zfjp.onrender.com";
class Upload extends React.Component {
  //function to redirect to a specific page
  // function takes information provided by the user in upload form, validates it. if valid alerts that upload is successful and returns to home page.
  handleSubmit = (event) => {
    event.preventDefault();
    const title = event.target.title;
    const description = event.target.description;
    if (!title.value.trim()) {
      title.focus();
      title.classList.add("input--error");
    } else if (!description.value.trim()) {
      description.focus();
      description.classList.add("input--error");
    } else {
      const postVideo = axios.post(videoLink, {
        title: title.value,
        description: description.value,
        image: "/images/upload-image.jpg",
      });
      postVideo
        .then((res) => {
          alert("Video upload successful!");
          this.props.history.push("/");
        })
        .catch((err) => {
          alert("There was an issue with the upload. Please try again");
          console.log(err);
        });
    }
  };

  render() {
    return (
      <div className="upload">
        <div className="upload__wrapper">
          <h1 className="upload__title">Upload Video</h1>
          <form onSubmit={this.handleSubmit}>
            <div className="upload__container">
              <div className="upload__img-container">
                <p className="label-btn">video thumbnail</p>
                <img className="upload__thumbnail" src={uploadImg} alt="" />
              </div>
              <div className="form">
                <label className="label-btn form__label" htmlFor="title">
                  title your video
                  <input
                    id="title"
                    name="title"
                    type="text"
                    className="input form__title-field"
                    placeholder="Add a title to your video"
                  />
                </label>
                <label htmlFor="description" className="label-btn form__label">
                  Add a video description
                  <textarea
                    id="description"
                    name="description"
                    placeholder="Add a description to your video"
                    className="input form__description"
                  ></textarea>
                </label>
              </div>
            </div>
            <div className="buttons">
              <button className="buttons__publish label-btn btn" type="submit">
                <img src={upload} alt="upload" className="btn__img" />{" "}
                <span className="btn__text">publish</span>{" "}
              </button>
              <Link to="/home">
                <button className="label-btn  btn buttons__cancel">
                  <span className="btn__text">cancel</span>
                </button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Upload;
